import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConciliacaoService } from '../../services/conciliacao.service';
import { OrigemLancamento } from '../../../../../shared/models/enums/origem-lancamento';
import { LancamentoPrincipal } from '../../models/lancamento-principal';
import { BancoOrigemEnum, BancoOrigemEnumNome } from '../../../../../shared/models/enums/banco-origem-enum';
import { ModoPaginaEnum } from '../../../../../models/enum/modo-pagina-enum';

@Component({
  selector: 'app-card-lancamentos',
  templateUrl: './card-lancamentos.component.html',
  styleUrl: './card-lancamentos.component.scss',
  standalone: false,
})
export class CardLancamentosComponent implements OnInit, OnDestroy {

  @Input() tipoCard: OrigemLancamento;
  @Input() conciliacaoId: number;

  excelFileType: string = ".xlsx";
  titulo: string = "";
  somaValoresSelecionados = 0;
  numberOfSelectedNodes = 0;
  autoMultiSelect: boolean = false;
  expandedRows = {};
  cardEhBanco: boolean = false;

  subscriptions: Subscription[] = [];

  get tipoBanco(): BancoOrigemEnum { return this.conciliacaoService.tipoBanco; }
  get modoEdicao(): boolean { return this.conciliacaoService.modoPagina === ModoPaginaEnum.Edicao; }

  _selectedRows: LancamentoPrincipal[] = [];
  get selectedRows(): LancamentoPrincipal[] { return this._selectedRows; }
  set selectedRows(value: LancamentoPrincipal[]) {
    this._selectedRows = value;
    this.onUpdateRowSelection();
  }

  lancamentos: LancamentoPrincipal[] = [];
  lancamentosExibidos: LancamentoPrincipal[] = []
  lancamentosClone: { [s: number]: LancamentoPrincipal } = {};

  constructor(
    private conciliacaoService: ConciliacaoService,
  ) { }

  ngOnInit(): void {
    this.cardEhBanco = this.tipoCard === OrigemLancamento.Banco;
    if (this.cardEhBanco) {
      this.titulo = `Extrato ${BancoOrigemEnumNome.get(this.tipoBanco) as string}`;
      this.subscriptions.push(this.conciliacaoService.onUpdateSelectionBanco.subscribe(() => this.onUpdateSelectionFromService()));
    }
    else {
      this.titulo = "Caixa";
      this.subscriptions.push(this.conciliacaoService.onUpdateSelectionCaixa.subscribe(() => this.onUpdateSelectionFromService()));
    }
    this.subscriptions.push(this.conciliacaoService.onUpdateDadosConciliacao.subscribe(() => this.updateLancamentosExibidos()));
    this.updateLancamentosExibidos();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.unselectItens();
  }

  private onUpdateSelectionFromService(): void {
    if (this.cardEhBanco)
      this.selectedRows = this.conciliacaoService.lancamentosSelecionadosBanco;
    else
      this.selectedRows = this.conciliacaoService.lancamentosSelecionadosCaixa;
  }

  private onUpdateRowSelection(): void {
    this.numberOfSelectedNodes = this.selectedRows.length;
    this.somaValoresSelecionados = this.conciliacaoService.updateValoresSelecionados(this.selectedRows, this.cardEhBanco);
  }

  private updateLancamentosExibidos(): void {
    if (this.cardEhBanco)
      this.lancamentos = this.conciliacaoService.lancamentosBanco;
    else
      this.lancamentos = this.conciliacaoService.lancamentosCaixa;

    this.lancamentosExibidos = [...this.lancamentos];
  }

  public esconderLancamentosConciliados(): void {
    this.lancamentosExibidos = this.lancamentos.filter(x => !x.conciliado && !(x.ehAgrupador && x.valorX100 === 0));
  }

  public exibirTodosLancamentos(): void {
    this.lancamentosExibidos = [...this.lancamentos];
  }

  public unselectItens(): void {
    this.selectedRows = [];
    this.onUpdateRowSelection();
  }
}
